var render = function render(){var _vm=this,_c=_vm._self._c;return _c('vue-seamless-scroll',{staticClass:"warp",attrs:{"data":_vm.listData}},[_c('ul',{staticClass:"item"},_vm._l((_vm.listData),function(item,index){return _c('li',{key:index},[_c('span',{staticClass:"title",domProps:{"textContent":_vm._s(item.title)}}),_c('span',{staticClass:"date",domProps:{"textContent":_vm._s(item.date)}})])}),0)])
}
var staticRenderFns = []

export { render, staticRenderFns }